import React, { useEffect } from 'react';
import useSharedDocHeader from "./DocHeaderHook";
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import {ListItemButton,ListItemText} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import Link from './Link';
import {useQuery} from 'react-query';
import pdf from './NoraVest_Bilder17_01_24.pdf';

const linksQuery = () => ({
  queryKey: ['links'],
  queryFn: async () => fetch('/data/links.json'
  ,{
    headers : { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(res =>
    res.json()
  ),option:{staleTime:1000*60*5}
})

export const loader =
  (queryClient) =>
  async ({ }) => {
    const query = linksQuery();
    // ⬇️ return data or fetch it
    return (
      queryClient.getQueryData(query.queryKey) ??
      (await queryClient.fetchQuery(query))
    )
  }

export default function Links() {
  const {doSetTitleKey,doSetMetaDescKey,doSetRouterId} = useSharedDocHeader();

  const { isLoading, isSuccess,error, data } = useQuery(linksQuery());

  useEffect(() => {
      doSetTitleKey("common:LABEL_LINKS");
      doSetMetaDescKey("common:LABEL_DESC_LINKS");
      doSetRouterId("/Links");
  }, []);

  if (isLoading){ 
    return 'Loading...';
  }

  if (error){ 
    return 'An error has occurred: ' + error.message;
  }

  if (isSuccess){
    return (
      <Grid2 height="100vh" container flexDirection="column" sx={{flexGrow:1,mt:{xs:2,sm:6},}}>
        <Grid2  width="100%" display="flex"  sx={{pt:4,bgcolor: 'background.paper'}}>
          <Box sx={{mx:'auto',pt:4, bgcolor: 'background.paper' }}>
            <List>
              <Link key={0} href={pdf} label={'Facetten der Buntheit, Eva Bächtold'}/>
              {data.map((item, index) => (
                <Link key={item.id} href={item.href} label={item.title}/>
              ))}
              
            </List>
          </Box>
        </Grid2>
      </Grid2>
    )
  }
}